// extracted by mini-css-extract-plugin
module.exports = {"social__icons__login":"footer_social__icons__login__1jZQe","social_link__login":"footer_social_link__login__12v7I","footer_end":"footer_footer_end__1pxxC"};